// Validation check fields for DerivedBusinessRole
export const validationCheckFields = [
    { key: 'validation_TemplateBusinessRole', labelKey: 'TemplateBusinessRole' },
    { key: 'validation_DifferentiationValue', labelKey: 'DifferentiationValue' },
    { key: 'validation_FriendlyName', labelKey: 'FriendlyName' },
    { key: 'validation_Action', labelKey: 'Action' },
    { key: 'validation_ApproversToAdd', labelKey: 'ApproversToAdd' },
    { key: 'validation_ApproversToRemove', labelKey: 'ApproversToRemove' },
    { key: 'validation_ActionInsertConflict', labelKey: 'ActionInsertConflict' },
    { key: 'validation_ActionUpdateConflict', labelKey: 'ActionUpdateConflict' },
    { key: 'validation_PublishInASPConflict', labelKey: 'PublishInASPConflict' },
    { key: 'validation_LastFailed', labelKey: 'LastFailed' },
    { key: 'validation_LastFailedError', labelKey: 'LastFailedError' },
]
